import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const NAV_LINKS = [
  { label: '首页', to: '/' },
  { label: '分类榜单', to: '/category' },
  { label: '连载进度', to: '/progress' },
  { label: '关于我们', to: '/about' },
  { label: '常见问题', to: '/faq' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [keyword, setKeyword] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const submitSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/category?q=${encodeURIComponent(q)}` : '/category');
    setOpen(false);
  };

  const solid = scrolled || open;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        solid ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200' : 'bg-transparent'
      }`}
    >
      <nav className="mx-auto flex h-16 md:h-[72px] max-w-7xl items-center justify-between px-4 md:px-6">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap" aria-label="韩国漫画大全 首页">
          <span className={`flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-white ${scrolled ? '' : ''}`}>
            <i className="ri-book-open-fill text-lg"></i>
          </span>
          <span className={`font-heading text-lg md:text-xl ${solid ? 'text-primary-700' : 'text-white'}`}>
            韩国漫画大全
          </span>
        </Link>

        {/* Desktop links */}
        <ul className="hidden items-center gap-1 md:flex">
          {NAV_LINKS.map((l) => (
            <li key={l.to}>
              <Link
                to={l.to}
                className={`rounded-md px-3 py-2 text-sm whitespace-nowrap transition-colors ${
                  solid ? 'text-foreground-800 hover:bg-background-100 hover:text-primary-700' : 'text-white/90 hover:text-white'
                }`}
              >
                {l.label}
              </Link>
            </li>
          ))}
        </ul>

        {/* Search */}
        <div className="hidden items-center gap-3 md:flex">
          <form onSubmit={submitSearch} className="flex items-center">
            <div className="flex items-center gap-2 rounded-full bg-background-100 px-3 py-2 focus-within:ring-2 focus-within:ring-primary-300">
              <i className="ri-search-line text-sm text-foreground-500"></i>
              <input
                type="search"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索韩漫 / 分类"
                className="w-36 bg-transparent text-sm text-foreground-800 outline-none placeholder:text-foreground-400"
                aria-label="搜索漫画"
              />
            </div>
          </form>
          <Link
            to="/category"
            className="whitespace-nowrap rounded-full bg-primary-500 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-primary-600"
          >
            浏览全部
          </Link>
        </div>

        {/* Mobile toggle */}
        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className={`flex h-9 w-9 items-center justify-center rounded-md md:hidden ${solid ? 'text-foreground-900' : 'text-white'}`}
          aria-label="打开菜单"
          aria-expanded={open}
        >
          <i className={open ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'}></i>
        </button>
      </nav>

      {/* Mobile menu */}
      {open && (
        <div className="border-t border-background-200 bg-background-50 md:hidden">
          <div className="mx-auto max-w-7xl px-4 py-3">
            <form onSubmit={submitSearch} className="mb-3 flex items-center gap-2 rounded-full bg-background-100 px-3 py-2">
              <i className="ri-search-line text-sm text-foreground-500"></i>
              <input
                type="search"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索韩漫 / 分类"
                className="w-full bg-transparent text-sm text-foreground-800 outline-none placeholder:text-foreground-400"
                aria-label="搜索漫画"
              />
            </form>
            <ul className="flex flex-col gap-1">
              {NAV_LINKS.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    onClick={() => setOpen(false)}
                    className="block rounded-md px-3 py-2.5 text-sm text-foreground-800 hover:bg-background-100"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </header>
  );
}